export default __webpack_public_path__ + "static/media/profile.7f42b582.png";